// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1-Yy1","emails":"CreateEditClinics_emails__2V0aJ","emailTagLabel":"CreateEditClinics_emailTagLabel__gYcnz"};